import styled, { css } from "styled-components"

import { hideElement } from "../../../assets/styles/helpers/common"

export const unstyledList = css`
  --dots-appearance: none;

  --left-padding: 0;
  --bottom-padding: 0;
`

export const UnstyledList = styled.ul`
  ${unstyledList}
`

// Text for screen readers and search engines only, e.g. the post title
// after a "Read more" link.
export const VisuallyHidden = styled.span`
  ${hideElement}
`
